export interface WorkflowContentInput {
  nodes: ReadonlyArray<{
    id: string;
    type?: string;
    position: { x: number; y: number };
    data: unknown;
  }>;
  edges: ReadonlyArray<{
    id: string;
    source: string;
    target: string;
    sourceHandle?: string | null;
    targetHandle?: string | null;
    data?: unknown;
  }>;
  workflowName?: string;
  workflowDescription?: string;
}

/**
 * Stable string identity of what a workflow actually contains, for "has the
 * canvas changed" checks (the unsaved-changes baseline, the chat-apply undo
 * guard). Order-independent, and deliberately blind to selection and other
 * React Flow interaction state, which never counts as an edit.
 */
export function workflowContentKey({
  nodes,
  edges,
  workflowName,
  workflowDescription,
}: WorkflowContentInput): string {
  const byId = (a: { id: string }, b: { id: string }) =>
    a.id.localeCompare(b.id);
  return JSON.stringify({
    nodes: [...nodes].sort(byId).map((node) => ({
      id: node.id,
      type: node.type,
      position: node.position,
      data: node.data,
    })),
    edges: [...edges].sort(byId).map((edge) => ({
      id: edge.id,
      source: edge.source,
      target: edge.target,
      sourceHandle: edge.sourceHandle ?? null,
      targetHandle: edge.targetHandle ?? null,
      data: edge.data,
    })),
    workflowName,
    workflowDescription,
  });
}
